export const HOME_PATH = "/";
export const SIGNIN_PATH = "/iniciar-sesion";

export const TERMS_PATH = "/terminos-y-condiciones";
export const PRIVACY_PATH = "/aviso-de-privacidad";
export const PRIVACY_DRIVER_PATH = "/aviso-de-privacidad-driver";

export const USER_HOME_PATH = "/";
export const USER_ORDER_PATH = "/ordenes/:id";
export const USER_GENERAL_PATH = "/general";
export const USER_ORDERS_PATH = "/ordenes";
export const USER_ACCOUNT_PATH = "/mi-cuenta";
export const USER_ADD_DRIVER_PATH = "/repartidores/nuevo";
export const USER_DRIVERS_PATH = "/repartidores";
export const USER_PROMOS_PATH = "/carrusel";

export const ADMIN_HOME_PATH = "/admin";
export const ADMIN_RESTAURANTS_PATH = "/admin/restaurantes";
export const ADMIN_RESTAURANT_PATH = "/admin/restaurantes/:id";
export const ADMIN_ACCOUNT_PATH = "/admin/mi-cuenta";
export const ADMIN_MENU_PATH = "/admin/menu";

export const RECEPTIONIST_HOME_PATH = "/receptionist";
export const RECEPTIONIST_ORDERS_PATH = "/receptionist/ordenes";
export const RECEPTIONIST_ORDER_PATH = "/receptionist/ordenes/:id";
export const RECEPTIONIST_ACCOUNT_PATH = "/receptionist/mi-cuenta";
